<template>
  <div>
    <el-descriptions border size="small" :column="1" class="mb-4">
      <el-descriptions-item :label="'差异结果'" :labelStyle="{ width: '80px' }">
        <el-tag v-if="row.added" size="mini">新增</el-tag>
        <el-tag v-if="row.changed" size="mini" type="success">有更新</el-tag>
        <el-tag v-if="row.removed" size="mini" type="danger">已删除</el-tag>
      </el-descriptions-item>
      <el-descriptions-item :label="'差异说明'" :labelStyle="{ width: '80px' }">
        {{ diffDesc }}
      </el-descriptions-item>
    </el-descriptions>

    <DTable :data="diffDetail" />
  </div>
</template>

<script>
import DTable from './table.vue'
export default {
  components: { DTable },
  props: {
    disabled: { type: Boolean, default: false },
    row: { type: Object, default: () => {} },
    columns: { type: Array, default: () => [] },
  },
  computed: {
    diffDesc() {
      if (!this.row) return ''
      const { added, removed, changed, originIndex, currentIndex } = this.row
      if (changed) return `原始文件第【${originIndex + 2}】行数据，有更新`
      if (added) return `更新文件第【${currentIndex + 2}】行，是新增记录`
      if (removed) return `原始文件第【${originIndex + 2}】行数据，被删除`
      return ''
    },
    diffDetail() {
      if (!this.columns || !this.columns.length) return []
      const row = this.row || {}
      const { added = false } = row
      const modifyCols = row.modifyCols || {}
      return this.columns.map(({ label, field }) => {
        const origin = row[field]
        const current = modifyCols[field]
        return {
          field: label,
          origin: !added ? origin : '',
          current: added ? origin : current,
        }
      })
    },
  },
}
</script>
